export default __webpack_public_path__ + "static/media/dcall.94da0ae9.svg";